module.exports = __webpack_public_path__ + "ui-static/img/bg-launcher.7e1c61cb.png";